import "./vaultItem.css";
import Inpt from "../inpt/Inpt";

// умножаем "5,4,..." на "4,2.5,..." получаем "20,10,..."
export const splitAndMultiplyStrings = (numberStr, dividedByStr) => {
  const dividedByA = dividedByStr.split(",");

  return numberStr
    .split(",")
    .reduce(
      (prevSum, curNumber, curIndex) =>
        prevSum +
        (prevSum ? ", " : "") +
        +(+curNumber * +dividedByA[curIndex]).toFixed(4),
      ""
    );
};

// делим "20,10,..." на "5,4,...", получаем "4,2.5,..."
export const splitAndDivideStrings = (numberStr, dividedByStr) => {
  const dividedByA = dividedByStr.split(",");

  return numberStr
    .split(",")
    .reduce(
      (prevSum, curNumber, curIndex) =>
        prevSum +
        (prevSum ? ", " : "") +
        +(+curNumber / +dividedByA[curIndex]).toFixed(4),
      ""
    );
};

export default function VaultItem({
  title,
  inputs,
  token,
  data,
  inputChange,
  showTitle = true,
  showSetBtn = false,
}) {
  const labelBalanceUsd = () => {
    return (
      title +
      " in $, " +
      inputs[token]
        .split(",")
        .reduce(
          (prevSum, cur) => prevSum + (prevSum ? "," : "") + cur + "$",
          ""
        )
    );
  };

  const labelExchangeRate = () => {
    return (
      "Exchange Rate, " +
      inputs[token]
        .split(",")
        .reduce(
          (prevSum, cur) => prevSum + (prevSum ? ", " : "") + cur + "/$",
          ""
        )
    );
  };

  return (
    <div className="vaultItem">
      {showTitle ? <h2>{title}</h2> : ""}
      {/* <label className="header">Balance, {inputs.lpToken}:</label>
      <input
        name="balance"
        value={inputs.balance}
        type="text"
        placeholder="592.8448"
        onChange={inputChange}
      /> */}
      <Inpt
        label={title + " " + inputs[token]}
        name={data[0].name}
        val={inputs[data[0].name]}
        type="text"
        placeholder={data[0].placeholder}
        onChg={inputChange}
        showSetBtn={showSetBtn}
      />

      {inputs[data[0].name] && inputs[data[2].name] ? (
        <div className="calcField small">
          <label>{labelBalanceUsd() + ": "}</label>
          {/* {+(inputs[data[0].name] * inputs[data[2].name]).toFixed(4)} */}
          <span>
            {splitAndMultiplyStrings(
              inputs[data[0].name],
              inputs[data[2].name]
            )}
          </span>
        </div>
      ) : (
        <Inpt
          label={labelBalanceUsd()}
          name={data[1].name}
          val={inputs[data[1].name]}
          type="text"
          placeholder={data[1].placeholder}
          onChg={inputChange}
          showSetBtn={showSetBtn}
        />
      )}

      {inputs[data[0].name] && inputs[data[1].name] ? (
        <div className="calcField small">
          <label>{labelExchangeRate() + ": "}</label>
          {/* {+(inputs[data[0].name] / inputs[data[1].name]).toFixed(4)} */}
          {splitAndDivideStrings(inputs[data[1].name], inputs[data[0].name])}
        </div>
      ) : (
        <Inpt
          label={labelExchangeRate()}
          name={data[2].name}
          val={inputs[data[2].name]}
          type="text"
          placeholder={data[2].placeholder}
          onChg={inputChange}
        />
      )}
    </div>
  );
}
